import { ROLES } from "./roles";

export const ROUTE_PERMISSIONS = {
  // 🔐 Admin only
  "/dashboard": [ROLES.SuperAdmin],
  "/exams": [ROLES.SuperAdmin],
  "/subjects": [ROLES.SuperAdmin],
  "/sets": [ROLES.SuperAdmin],
  "/configure-question": [ROLES.SuperAdmin],
  "/sheets-data": [ROLES.SuperAdmin],
  "/bulk-upload": [ROLES.SuperAdmin],
  "/groups": [ROLES.SuperAdmin],
  "/students": [ROLES.SuperAdmin],
  "/examiner": [ROLES.SuperAdmin],
  "/model-answer": [ROLES.SuperAdmin],
  "/marks": [ROLES.SuperAdmin],
  "/generate-report": [ROLES.SuperAdmin],
  "/generate-marks-report": [ROLES.SuperAdmin],
  "/generate-workstation": [ROLES.SuperAdmin],
  "/workstations": [ROLES.SuperAdmin],
  "/generate-candidate-key": [ROLES.SuperAdmin],
  "/answer-sheets": [ROLES.SuperAdmin],
  "/es": [ROLES.SuperAdmin],
  "/pdf-requests": [ROLES.SuperAdmin],

  // 🧑‍🏫 Examiner
  "/questions": [ROLES.Examiner],
  "/reconsider": [ROLES.Examiner],

  // 👨‍🏫 Head Examiner
  "/examiners": [ROLES.HeadExaminer],
  "/he-set": [ROLES.HeadExaminer],
  "/examiner-group": [ROLES.HeadExaminer],
  "/examiner-status": [ROLES.HeadExaminer],
  "/he-questions": [ROLES.HeadExaminer],
  "/he-evaluation": [ROLES.HeadExaminer],
  "/he-moderation": [ROLES.HeadExaminer],
  "/selection": [ROLES.HeadExaminer],
  "/mod_evaluation": [ROLES.HeadExaminer],
  "/mod_overview": [ROLES.HeadExaminer],
  "/oq-sheet": [ROLES.HeadExaminer],

  // Examiner and Head Examiner
  "/examiner-dashboard": [ROLES.Examiner, ROLES.HeadExaminer],
  "/question-evaluation": [ROLES.Examiner, ROLES.HeadExaminer],

  // Super Admin and Head Examiner
  "/oq-mapping": [ROLES.SuperAdmin, ROLES.HeadExaminer],

  // Section Officer
  "/cs-listing": [ROLES.SectionOfficer],

  // SectionOfficer and SuperAdmin
  "/vcs": [ROLES.SuperAdmin, ROLES.SectionOfficer],

  // 🧾 Shared (multiple roles allowed)
  "/change-password": Object.values(ROLES),
  "/rsa": Object.values(ROLES),
  "/404": Object.values(ROLES),
  "/maintenance": Object.values(ROLES),
};
